// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1200px) {
  .SelectReference_wrap__9GOK2 {
    position: absolute;
    width: 256px;
    z-index: 3;
    background-color: var(--white);
    border: 1px solid var(--gray-100);
    border-radius: 4px;
    padding: 8px;
  }
}
.SelectReference_wrap__9GOK2 .employees__grid {
  display: block;
}
.SelectReference_wrap__9GOK2 .searchBlock {
  margin-bottom: 16px;
  margin-top: 0;
}
@media (min-width: 1200px) {
  .SelectReference_wrap__9GOK2 .searchBlock {
    margin-bottom: 4px;
  }
}
.SelectReference_wrap__9GOK2 .searchBlock input {
  height: 28px;
  border-radius: 4px;
  padding: 6px;
  background: #F0F1F5;
}
.SelectReference_wrap-is-objects__TFn8v {
  max-width: 630px;
  width: 100%;
}

.SelectReference_footer__XVmdW {
  display: flex;
  align-items: center;
  grid-column-gap: 8px;
  padding-top: 8px;
}
@media (min-width: 1200px) {
  .SelectReference_footer__XVmdW {
    grid-column-gap: 4px;
  }
}

.SelectReference_btnSubmit__ViguV {
  flex: 1 1;
}

.SelectReference_btnReset__-rmuy {
  width: auto;
}

.SelectReference_grid__k-syf {
  display: block;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
  margin-bottom: 12px;
}
@media (min-width: 768px) {
  .SelectReference_grid__k-syf {
    display: grid;
  }
}
.SelectReference_grid--is-skeleton__CPA2a {
  margin-bottom: 0;
}

.SelectReference_skeleton__4VK-D {
  width: 100%;
  height: 164px;
  border-radius: 12px;
  margin-bottom: 12px;
}
.SelectReference_skeleton__4VK-D:last-child {
  margin-bottom: 0;
}
@media (min-width: 768px) {
  .SelectReference_skeleton__4VK-D {
    margin-bottom: 0;
  }
}
.SelectReference_skeleton--sm__IIQgU {
  height: 34px;
  margin-bottom: 2px;
}
.SelectReference_skeleton--xl__HfjIC {
  height: 56px;
  margin-bottom: 2px;
}

.SelectReference_label__XiT82 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding-right: 6px;
}
@media (min-width: 1200px) {
  .SelectReference_label__XiT82 {
    padding-right: 0;
  }
}
@media (hover: hover) {
  .SelectReference_label__XiT82:hover svg {
    color: var(--white);
  }
}
.SelectReference_label__XiT82 .SelectReference_item__8lG7J {
  flex: 1 1;
  padding-right: 24px;
}

.SelectReference_inputWrap__NV6Fi {
  flex-shrink: 0;
  color: var(--accent-color);
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1200px) {
  .SelectReference_inputWrap__NV6Fi {
    position: absolute;
    right: 0;
    width: auto;
    height: auto;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.SelectReference_inputWrap__NV6Fi svg {
  display: none;
}
@media (min-width: 1200px) {
  .SelectReference_inputWrap__NV6Fi svg {
    display: flex;
  }
}
.SelectReference_inputWrap__NV6Fi input:checked ~ .SelectReference_itemIco__sfU0\\+ {
  border-color: transparent;
  background-color: var(--accent-color);
}

.SelectReference_itemIco__sfU0\\+ {
  display: flex;
  border-radius: 50%;
  width: 14px;
  min-width: 14px;
  height: 14px;
  border: 1px solid #D9D9D9;
  position: relative;
  transition: 0.2s;
}
@media (min-width: 640px) {
  .SelectReference_itemIco__sfU0\\+ {
    width: 20px;
    min-width: 20px;
    height: 20px;
  }
}
@media (min-width: 1200px) {
  .SelectReference_itemIco__sfU0\\+ {
    display: none;
  }
}
.SelectReference_itemIco__sfU0\\+::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
}
@media (min-width: 640px) {
  .SelectReference_itemIco__sfU0\\+::before {
    width: 12px;
    height: 12px;
  }
}
@media (min-width: 1200px) {
  .SelectReference_itemIco__sfU0\\+::before {
    width: 6px;
    height: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SelectReference/SelectReference.module.scss"],"names":[],"mappings":"AACE;EADF;IAEI,kBAAA;IACA,YAAA;IACA,UAAA;IACA,8BAAA;IACA,iCAAA;IACA,kBAAA;IACA,YAAA;EACF;AACF;AAGM;EACE,cAAA;AADR;AAKI;EACE,mBAAA;EACA,aAAA;AAHN;AAKM;EAJF;IAKI,kBAAA;EAFN;AACF;AAIM;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAFR;AAcE;EACE,gBAAA;EACA,WAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAbF;AAeE;EANF;IAOI,oBAAA;EAZF;AACF;;AAeA;EACE,SAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,cAAA;EACA,qCAAA;EACA,cAAA;EACA,mBAAA;AAZF;AAcE;EANF;IAOI,aAAA;EAXF;AACF;AAaE;EACE,gBAAA;AAXJ;;AAeA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EAEA,mBAAA;AAbF;AAeE;EACE,gBAAA;AAbJ;AAgBE;EAXF;IAYI,gBAAA;EAbF;AACF;AAeE;EACE,YAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,YAAA;EACA,kBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAfF;AAiBE;EAPF;IAQI,gBAAA;EAdF;AACF;AAgBE;EAEI;IACE,mBAAA;EAfN;AACF;AAmBE;EACE,SAAA;EACA,mBAAA;AAjBJ;;AAqBA;EACE,cAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAlBF;AAoBE;EATF;IAUI,kBAAA;IACA,QAAA;IACA,WAAA;IACA,YAAA;IACA,QAAA;IACA,gCAAA;EAjBF;AACF;AAmBE;EACE,aAAA;AAjBJ;AAmBI;EAHF;IAII,aAAA;EAhBJ;AACF;AAoBI;EACE,yBAAA;EACA,qCAAA;AAlBN;;AAuBA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AApBF;AAsBE;EAVF;IAWI,WAAA;IACA,eAAA;IACA,YAAA;EAnBF;AACF;AAqBE;EAhBF;IAiBI,aAAA;EAlBF;AACF;AAoBE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAlBJ;AAoBI;EAXF;IAYI,WAAA;IACA,YAAA;EAjBJ;AACF;AAmBI;EAhBF;IAiBI,UAAA;IACA,WAAA;EAhBJ;AACF","sourcesContent":[".wrap {\r\n  @media (min-width: 1200px) {\r\n    position: absolute;\r\n    width: 256px;\r\n    z-index: 3;\r\n    background-color: var(--white);\r\n    border: 1px solid var(--gray-100);\r\n    border-radius: 4px;\r\n    padding: 8px;\r\n  }\r\n\r\n  :global {\r\n    .employees {\r\n      &__grid {\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    .searchBlock {\r\n      margin-bottom: 16px;\r\n      margin-top: 0;\r\n\r\n      @media (min-width: 1200px) {\r\n        margin-bottom: 4px;\r\n      }\r\n\r\n      input {\r\n        height: 28px;\r\n        border-radius: 4px;\r\n        padding: 6px;\r\n        background: #F0F1F5;\r\n      }\r\n    }\r\n  }\r\n\r\n  // &--is-top {\r\n  //   // @media (min-width: 1200px) {\r\n  //   //   top: auto;\r\n  //   //   bottom: calc(100% + 6px);\r\n  //   // }\r\n  // }\r\n\r\n  &-is-objects {\r\n    max-width: 630px;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  align-items: center;\r\n  grid-column-gap: 8px;\r\n  padding-top: 8px;\r\n\r\n  @media (min-width: 1200px) {\r\n    grid-column-gap: 4px;\r\n  }\r\n}\r\n\r\n.btnSubmit {\r\n  flex: 1;\r\n}\r\n\r\n.btnReset {\r\n  width: auto;\r\n}\r\n\r\n.grid {\r\n  display: block;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  grid-gap: 12px;\r\n  margin-bottom: 12px;\r\n\r\n  @media (min-width: 768px) {\r\n    display: grid;\r\n  }\r\n\r\n  &--is-skeleton {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.skeleton {\r\n  width: 100%;\r\n  height: 164px;\r\n  border-radius: 12px;\r\n\r\n  margin-bottom: 12px;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (min-width: 768px) {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  &--sm {\r\n    height: 34px;\r\n    margin-bottom: 2px;\r\n  }\r\n\r\n  &--xl {\r\n    height: 56px;\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n.label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: relative;\r\n  padding-right: 6px;\r\n\r\n  @media (min-width: 1200px) {\r\n    padding-right: 0;\r\n  }\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      svg {\r\n        color: var(--white);\r\n      }\r\n    }\r\n  }\r\n\r\n  .item {\r\n    flex: 1;\r\n    padding-right: 24px;\r\n  }\r\n}\r\n\r\n.inputWrap {\r\n  flex-shrink: 0;\r\n  color: var(--accent-color);\r\n  width: 22px;\r\n  height: 22px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  @media (min-width: 1200px) {\r\n    position: absolute;\r\n    right: 0;\r\n    width: auto;\r\n    height: auto;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  svg {\r\n    display: none;\r\n\r\n    @media (min-width: 1200px) {\r\n      display: flex;\r\n    }\r\n  }\r\n\r\n  input:checked {\r\n    &~.itemIco {\r\n      border-color: transparent;\r\n      background-color: var(--accent-color);\r\n    }\r\n  }\r\n}\r\n\r\n.itemIco {\r\n  display: flex;\r\n  border-radius: 50%;\r\n  width: 14px;\r\n  min-width: 14px;\r\n  height: 14px;\r\n  border: 1px solid #D9D9D9;\r\n  position: relative;\r\n  transition: 0.2s;\r\n\r\n  @media (min-width: 640px) {\r\n    width: 20px;\r\n    min-width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    display: none;\r\n  }\r\n\r\n  &::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 6px;\r\n    height: 6px;\r\n    background: #fff;\r\n    border-radius: 50%;\r\n\r\n    @media (min-width: 640px) {\r\n      width: 12px;\r\n      height: 12px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      width: 6px;\r\n      height: 6px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `SelectReference_wrap__9GOK2`,
	"wrap-is-objects": `SelectReference_wrap-is-objects__TFn8v`,
	"footer": `SelectReference_footer__XVmdW`,
	"btnSubmit": `SelectReference_btnSubmit__ViguV`,
	"btnReset": `SelectReference_btnReset__-rmuy`,
	"grid": `SelectReference_grid__k-syf`,
	"grid--is-skeleton": `SelectReference_grid--is-skeleton__CPA2a`,
	"skeleton": `SelectReference_skeleton__4VK-D`,
	"skeleton--sm": `SelectReference_skeleton--sm__IIQgU`,
	"skeleton--xl": `SelectReference_skeleton--xl__HfjIC`,
	"label": `SelectReference_label__XiT82`,
	"item": `SelectReference_item__8lG7J`,
	"inputWrap": `SelectReference_inputWrap__NV6Fi`,
	"itemIco": `SelectReference_itemIco__sfU0+`
};
export default ___CSS_LOADER_EXPORT___;
